import { useState } from 'react'
import { MobileTitle, SystemTitle, Title } from '../../components/Title'
import { SystemBaiscs } from './SystemBasics'
import { Confine } from './Confine'
import { Confriend } from './Confriend'
import { Confire, Gadgets } from './Confire'
import { BaseSystem } from './BaseSystem'
import { PlayItYourWay } from './PlayItYourWay'
import { BattleFlow } from './BattleFlow'
import { Facilities } from './facilities/Facilities'

export const System = () => {
    const [activeSystem, setActiveSystem] = useState('battle')
    const [activeSubSystem, setActiveSubSystem] = useState('systembasics')

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }
    const SystemNav = () => {
        return (
            <nav className='flex flex-wrap [&>button]:w-[40%] [&>button]:md:w-[22%] justify-evenly md:pt-0  items-start max-w-[1200px] mx-auto'>
                <button>
                    <img
                        onClick={(e) => {
                            setActiveSystem('battle')
                            e.stopPropagation()
                            scrollToTop()
                        }}
                        className={`${
                            activeSystem === 'battle' && 'brightness-150'
                        } hover:brightness-150 mx-auto duration-300 `}
                        src={`${process.env.PUBLIC_URL}/images/system/header-battle-system-fr.webp`}
                        alt=''
                    />{' '}
                </button>{' '}
                <button>
                    {' '}
                    <span className='relative inline-block '>
                        <img
                            onClick={() => {
                                setActiveSystem('battleflow')
                                // scrollToTop()
                            }}
                            className={`${
                                activeSystem === 'battleflow' && 'brightness-150'
                            } hover:brightness-150 mx-auto duration-300`}
                            src={`${process.env.PUBLIC_URL}/images/system/header-battleflow-fr.webp`}
                            alt=''
                        />{' '}
                    </span>
                </button>{' '}
                <button>
                    <img
                        onClick={() => {
                            setActiveSystem('play')
                            // scrollToTop()
                        }}
                        className={`${
                            activeSystem === 'play' && 'brightness-150'
                        } hover:brightness-150 mx-auto duration-300`}
                        src={`${process.env.PUBLIC_URL}/images/system/header-playityourway-system-fr.webp`}
                        alt=''
                    />{' '}
                </button>{' '}
                <button>
                   
                    <span className='relative inline-block newicon'>
                        <img
                            onClick={() => {
                                setActiveSystem('facilities')
                                // scrollToTop()
                            }}
                            className={`${
                                activeSystem === 'facilities' && 'brightness-150'
                            } hover:brightness-150 mx-auto duration-300`}
                            src={`${process.env.PUBLIC_URL}/images/system/header-facilities-fr.webp`}
                            alt=''
                        />{' '}
                    </span>
                </button>{' '}
            </nav>
        )
    }
    const BattleSystemNav = () => {
        return (
            <nav className='mx-auto max-w-[1200px] my-8'>
                <ul className='[&>li>img]:mx-auto [&>li>img]:w-full [&>li]:w-[40%] [&>li]:md:w-[20%] cursor-pointer flex justify-center gap-4 flex-wrap mx-auto px-4 md:px-0 max-w-[1200px] items-end'>
                    <li>
                        <img
                            onClick={() => {
                                setActiveSubSystem('systembasics')
                                scrollToTop()
                            }}
                            className={` ${
                                activeSubSystem === 'systembasics' && 'brightness-125'
                            }  mx-auto hover:brightness-125 duration-300`}
                            alt='gamesystem button'
                            src={`${process.env.PUBLIC_URL}/images/system/header-systembasics-system-fr.png`}
                        />
                    </li>
                    <li>
                        <img
                            onClick={() => {
                                setActiveSubSystem('confine')
                                scrollToTop()
                            }}
                            className={` ${
                                activeSubSystem === 'confine' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='investigation button'
                            src={`${process.env.PUBLIC_URL}/images/system/header-confine-system-new-fr.webp`}
                        />
                    </li>
                    <li>
                        <img
                            onClick={() => {
                                setActiveSubSystem('confriend')
                                scrollToTop()
                            }}
                            className={` ${
                                activeSubSystem === 'confriend' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='confriend button'
                            src={`${process.env.PUBLIC_URL}/images/system/header-confriend-system-new-fr.webp`}
                        />
                    </li>
                    <li>
                        <img
                            onClick={() => {
                                setActiveSubSystem('confire')
                                scrollToTop()
                            }}
                            className={` ${
                                activeSubSystem === 'confire' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/system/header-confire-system-new-fr.webp`}
                        />
                    </li>
                </ul>
            </nav>
        )
    }
    return (
        <>
            <div className='md:mt-32'>
                <div className='py-12 md:py-0 w-full text-center mx-auto'>
                    <span className='newicon-mobilenav relative pt-2'>
                        <h1 className='md:hidden text-gradient-title text-lg font-pop inline-block'>Système</h1>{' '}
                    </span>
                </div>
                <div className=''>
                    <SystemNav />{' '}
                </div>
                {activeSystem === 'facilities' ? (
                    <Facilities />
                ) : activeSystem === 'play' ? (
                    <PlayItYourWay />
                ) : activeSystem === 'battleflow' ? (
                    <BattleFlow />
                ) : (
                    <>
                        <BattleSystemNav />
                        <div className='max-w-[1200px] mx-auto my-4 md:my-20'>
                            {(() => {
                                switch (activeSubSystem) {
                                    case 'systembasics':
                                        return <SystemBaiscs />
                                    case 'confine':
                                        return <Confine />
                                    case 'confriend':
                                        return <Confriend />
                                    case 'confire':
                                        return <Confire />
                                    case 'play':
                                        return <PlayItYourWay />
                                    default:
                                        return null
                                }
                            })()}
                        </div>{' '}
                        <BattleSystemNav />
                    </>
                )}
                <div className='py-4'>
                    {' '}
                    <SystemNav />
                </div>
            </div>
        </>
    )
}
